import { render, staticRenderFns } from "./ProductIntro.vue?vue&type=template&id=b5b23978&scoped=true&"
import script from "./ProductIntro.vue?vue&type=script&lang=js&"
export * from "./ProductIntro.vue?vue&type=script&lang=js&"
import style0 from "./ProductIntro.vue?vue&type=style&index=0&id=b5b23978&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b23978",
  null
  
)

export default component.exports